import { actionDo } from "../../infra/enums";

const stateINIT = {
  user: null,
  actionSelected: actionDo,
  story: { suspects: [] },
};

const Reducer = (state = stateINIT, action = {}) => {
  switch (action.type) {
    case "LOGOUT":
      return { ...state, ...{ user: null } };
    case "INIT":
      return { ...state, ...action };
    case "SET_STORY":
      return { ...state, story: action.data };
    case "SET_SUSPECT_SELECTED":
      return { ...state, suspectSelected: action.data };
    case "SET_ACTION_SELECTED":
      return { ...state, actionSelected: action.data };
    case "SET_USER":
      return { ...state, user: action.user, empresa: { ...action.empresa, random: new Date().getTime() } };
    default:
      return state;
  }
};

export default Reducer;
